/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'alert_1': {
    width: 16,
    height: 16,
    viewBox: '0 0 58.3 54',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M49.52 33.69L32.41 2.44a3.7 3.7 0 0 0-6.51 0L1 48a3.73 3.73 0 0 0 3.22 5.5h49.86a3.73 3.73 0 0 0 3.26-5.5l-4.88-8.92M29.14 18.08v19.01"/><circle pid="1" class="cls-1" cx="29.14" cy="41.95" r=".07"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/alert_1.js